import { Dispatch, RefObject, SetStateAction, useEffect } from 'react';

type Props = {
  lockActiveStateProps: boolean;
  lockActiveState: boolean;
  menuOpen: boolean;
  isFocused: boolean;
  menuRef: RefObject<HTMLDivElement | null>;
  selectedOptionsRef: RefObject<HTMLDivElement | null>;
  setMenuOpen: Dispatch<SetStateAction<boolean>>;
};

const useResetAttributes = ({
  lockActiveStateProps,
  lockActiveState,
  menuOpen,
  menuRef,
  isFocused,
  selectedOptionsRef,
  setMenuOpen,
}: Props) => {
  useEffect(() => {
    if (lockActiveStateProps || !lockActiveState) {
      return;
    }
    if (!menuOpen) {
      // clear any active menu option
      const activeMenuOption = document.querySelector('[data-menu-list-option-active="true"]');
      if (activeMenuOption) {
        activeMenuOption.setAttribute('data-menu-list-option-active', 'false');
      }
      // scroll to top of menu, but wait for it to close first
      setTimeout(() => {
        if (menuRef.current) {
          menuRef.current.scrollTo({ top: 0 });
        }
      }, 150);
    }
    if (!isFocused) {
      // clear everything and close menu
      setMenuOpen(false);
      const activeMenuOption = document.querySelector('[data-menu-list-option-active="true"]');
      if (activeMenuOption) {
        activeMenuOption.setAttribute('data-menu-list-option-active', 'false');
      }
      const activeRemoveOption = selectedOptionsRef.current?.querySelector('[data-remove-option-active="true"]');
      if (activeRemoveOption) {
        activeRemoveOption.setAttribute('data-remove-option-active', 'false');
      }
    }
  }, [menuOpen, isFocused, lockActiveStateProps, lockActiveState, menuRef, setMenuOpen, selectedOptionsRef]);
};

export default useResetAttributes;
